"use client";
import { useModal } from "@/lib/hooks/useModal";
import { Modal } from "@/components/ui/Modal";

export default function GlobalModal() {
  const { modals, closeModal } = useModal();

  return (
    <>
      {modals.map((modal, idx) => (
        <Modal
          key={idx}
          isOpen={true}
          onClose={() => closeModal(idx)}
          title={modal?.title}
          size={modal.size || "md"}
          fullscreen={modal.fullscreen || false}
          zIndexBase={idx * 40 + 1000}
        >
          {modal.content}
        </Modal>
      ))}
    </>
  );
}
